var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 162,
    viewBox: "0 0 153 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M148.658 50.7754L48.1719 157.253C49.8746 157.874 51.5932 158.434 53.331 158.917L150.228 56.2422C149.772 54.4007 149.244 52.5796 148.658 50.7754Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M144.64 40.7749L38.7334 152.996C40.2351 153.817 41.7612 154.577 43.3115 155.276L146.791 45.626C146.129 43.9865 145.412 42.3695 144.64 40.7749Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M151.439 62.0864L58.8467 160.198C60.8011 160.572 62.7695 160.863 64.7518 161.071L152.264 68.3437C152.067 66.2441 151.792 64.1584 151.439 62.0864Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M139.556 31.9053L30.3633 147.609C31.6923 148.605 33.0518 149.538 34.4319 150.427L142.214 36.2165C141.376 34.7541 140.496 33.3136 139.556 31.9053Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M71.1069 161.468C73.4145 161.504 75.7281 161.436 78.041 161.25L152.43 82.4252C152.606 79.9737 152.67 77.5228 152.636 75.0776L71.1069 161.468Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M24.289 25.4679C17.5092 32.6372 11.9664 41.0091 7.91187 50.2042L47.6339 8.11426C38.956 12.4105 31.055 18.2838 24.289 25.4679Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M75.0581 0.440456L0.669101 79.2674C0.492868 81.7189 0.430596 84.1704 0.464385 86.6149L81.9922 0.222119C79.6853 0.18772 77.3717 0.253714 75.0581 0.440456Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M94.6 157.962L149.325 99.974C150.201 96.8954 150.909 93.7659 151.445 90.6011L85.7559 160.207C88.7421 159.639 91.695 158.89 94.6 157.962Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M133.505 24.0571L22.958 141.197C24.1261 142.355 25.314 143.475 26.5357 144.532L136.648 27.8537C135.655 26.555 134.598 25.2955 133.505 24.0571Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M58.4995 3.72955L3.77441 61.7179C2.89811 64.7964 2.19023 67.9259 1.6543 71.0908L67.3436 1.48584C64.3573 2.05286 61.4044 2.80201 58.4995 3.72955Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M88.3486 0.616699L0.835449 93.3496C1.032 95.4487 1.30672 97.5344 1.65963 99.6069L94.2524 1.49004C92.2979 1.11468 90.33 0.823566 88.3486 0.616699Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M128.811 136.222C135.59 129.053 141.133 120.681 145.187 111.485L105.468 153.575C114.145 149.279 122.045 143.406 128.811 136.222Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M118.67 11.2637L10.8833 125.475C11.7221 126.937 12.6059 128.377 13.5427 129.786L122.736 14.0816C121.406 13.0862 120.047 12.1525 118.67 11.2637Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M99.7679 2.77539L2.87207 105.448C3.32723 107.291 3.85658 109.112 4.44093 110.915L104.926 4.43712C103.226 3.81792 101.507 3.25769 99.7679 2.77539Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M126.561 17.1582L16.4487 133.837C17.4478 135.134 18.5026 136.394 19.5964 137.632L130.142 20.4936C128.974 19.3366 127.785 18.2169 126.561 17.1582Z",
    fill: "#03098B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M109.786 6.41504L6.30786 116.066C6.97039 117.704 7.68748 119.321 8.45911 120.916L114.365 8.69666C112.862 7.87387 111.336 7.11333 109.786 6.41504Z",
    fill: "#03098B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightside);
export default __webpack_public_path__ + "static/media/rightside.0a47cc6fbb8ebd02336f88cc70fdfb31.svg";
export { ForwardRef as ReactComponent };